// extracted by mini-css-extract-plugin
export default {"wrapper":"Question_wrapper__BDnCT"};